import * as bodyScrollLock from 'body-scroll-lock';

const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

// The scrollbar gutter is reserved permanently in CSS (html { scrollbar-gutter: stable }),
// so locking scroll no longer reflows the layout — no gap compensation needed here.
const scrollLock = function(el) {
  window.lockedEl = el
  disableBodyScroll(el)
}

const scrollUnLock = function() {
  if (window.lockedEl) {
    enableBodyScroll(window.lockedEl)
  }
}

export { scrollLock, scrollUnLock }
